import {} from '@mui/material'

// material-ui

// project imports
import ViewProfileCommandsComponent from 'features/view/profile/commands/component/view-profile-commands-component'

// ==============================|| PROFILE 3 ||============================== //

// styles
const Profile3 = () => {
  return (
    <>
      <ViewProfileCommandsComponent />
    </>
  )
}

export default Profile3
